import { Alert, App, Button, Popconfirm } from 'antd'
import { User } from '../../models/User'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { useState } from 'react'
import { deleteUser } from '../../services/UserService'
import { useAuth } from '../../contexts/Auth'
import { useNavigate } from 'react-router-dom'

interface Props {
  user: User
}
const DeleteAlert = ({ user }: Props) => {
  const navigate = useNavigate()
  const { notification } = App.useApp()
  const { setIsLogged, updateCurrentUser } = useAuth()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const confirmationClicked = () => {
    setIsLoading(true)
    deleteUser(setIsLogged, updateCurrentUser)
      .then(() => {
        notification.success({
          message: i18n.t(LocalizationKeys.Page.UserProfilePage.AccountDeleted),
        })
        navigate('/auth/login')
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Alert
      showIcon
      type="error"
      style={{ alignItems: 'center', gap: 10 }}
      message={i18n.t(
        LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountTitle
      )}
      description={i18n.t(
        LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountDescription
      )}
      action={
        <Popconfirm
          title={i18n.t(
            LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountTitle
          )}
          description={i18n.t(
            LocalizationKeys.Page.UserProfilePage.DeleteWholeAccountDescription
          )}
          okText={i18n.t(
            LocalizationKeys.Page.ProfileSettingsPage.DeleteButton
          )}
          okButtonProps={{
            loading: isLoading,
            disabled: isLoading,
            danger: true,
          }}
          cancelButtonProps={{ loading: isLoading, disabled: isLoading }}
          cancelText={i18n.t(LocalizationKeys.Misc.Button.Cancel)}
          disabled={isLoading}
          onConfirm={confirmationClicked}
        >
          <Button danger loading={isLoading} disabled={isLoading}>
            {i18n.t(LocalizationKeys.Page.ProfileSettingsPage.DeleteButton)}
          </Button>
        </Popconfirm>
      }
    />
  )
}

type DeleteAlertType = { DeleteAlert: typeof DeleteAlert }

export { DeleteAlert, type DeleteAlertType }
